export default "__VITE_ASSET__438fab01__"